var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('p',[_vm._v("Loading...")]):_vm._e(),(!_vm.isLoading)?_c('base-table',{attrs:{"data":_vm.balance_data,"columns":_vm.table1.columns,"thead-classes":"text-primary"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }